// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3FOS2","resendInfoText":"OnGoingPaymentBox_resendInfoText__OYaci"};